// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {DeleteOutlined, DownOutlined, UpOutlined} from "@ant-design/icons";
import {Button, Col, Input, Modal, Row, Select, Switch, Table, Tooltip} from "antd";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";

class SyncerTableColumnTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      modalVisible: false,
      deleteTable: null,
    };

  }

  updateTable(table) {
    this.props.onUpdateTable(table);
  }

  updateField(table, index, key, value) {
    table[index][key] = value;
    this.updateTable(table);
  }

  addRow(table) {
    const row = {name: "", type: "string", localName: "", isHashed: false};
    if (table === undefined) {
      table = [];
    }
    table = Setting.addRow(table, row);
    this.updateTable(table);
  }

  deleteRow(table, i) {
    // Modal.confirm({
    //   title: i18next.t("提示"),
    //   content: i18next.t("确认删除该字段吗？"),
    //   onOk() {
    //     table = Setting.deleteRow(table, i);
    //     this.updateTable(table);
    //   },
    //   onCancel() {
    //   },
    // });
    table = Setting.deleteRow(table, i);
    this.setState({
      modalVisible: true,
      deleteTable: table,
    });
  }

  upRow(table, i) {
    table = Setting.swapRow(table, i - 1, i);
    this.updateTable(table);
  }

  downRow(table, i) {
    table = Setting.swapRow(table, i, i + 1);
    this.updateTable(table);
  }

  renderTable(table) {
    let columns = [
      {
        title: i18next.t("syncer:Databse field"),
        dataIndex: "name",
        key: "name",
        render: (text, record, index) => {
          return (
            <Input value={text} maxLength={200} onChange={e => {
              this.updateField(table, index, "name", e.target.value);
            }} />
          );
        },
      },
      // {
      //   title: i18next.t("数据类型"),
      //   dataIndex: "type",
      //   key: "type",
      //   render: (text, record, index) => {
      //     return (
      //       <Select disabled={record?.isPermanent} virtual={false} style={{width: "100%"}} value={text} onChange={(value => {this.updateField(table, index, "type", value);})}>
      //         {
      //           ["string", "integer", "boolean"]
      //             .map((item, index) => <Option key={index} value={item}>{item}</Option>)
      //         }
      //       </Select>
      //     );
      //   },
      // },
      {
        title: i18next.t("syncer:IAM field"),
        dataIndex: "localName",
        key: "localName",
        render: (text, record, index) => {
          const defaultLabel = this.props.localNames.find(localName => localName.id === text);
          const options = this.props.localNames.filter(localName => {
            const found = this.props.table.find(tableRow => {
              return tableRow.localName === localName.id;
            });
            if (found) {
              return false;
            }
            return true;
          }).map((option, index) => {
            return {label: option.value, value: option.id};
          });
          return (
            <Select disabled={record?.isPermanent} virtual={false} style={{width: "100%"}}
              onChange={(value => {
                this.updateField(table, index, "localName", value.value);
              })}
              labelInValue
              value={{
                value: text,
                label: defaultLabel?.value,
              }}
              options={options}
            >
            </Select>
          );
        },
      },
      {
        title: i18next.t("syncer:Need update"),
        dataIndex: "isHashed",
        key: "isHashed",
        render: (text, record, index) => {
          return (
            record?.isPermanent ? null :
              <Switch checked={text} onChange={checked => {
                this.updateField(table, index, "isHashed", checked);
              }} />
          );
        },
      },
      {
        title: i18next.t("general:Action"),
        key: "action",
        width: "100px",
        render: (text, record, index) => {
          return (
            <div>
              <Tooltip placement="bottomLeft" title={i18next.t("general:Up")}>
                <Button style={{marginRight: "5px"}} disabled={index === 0 || record?.isPermanent} icon={<UpOutlined />} size="small" onClick={() => this.upRow(table, index)} />
              </Tooltip>
              <Tooltip placement="topLeft" title={i18next.t("general:Down")}>
                <Button style={{marginRight: "5px"}} disabled={index === table.length - 1 || record?.isPermanent} icon={<DownOutlined />} size="small" onClick={() => this.downRow(table, index)} />
              </Tooltip>
              <Tooltip placement="topLeft" title={i18next.t("general:Delete")}>
                <Button disabled={record?.isPermanent} icon={<DeleteOutlined />} size="small" onClick={() => this.deleteRow(table, index)} />
              </Tooltip>
            </div>
          );
        },
      },
    ];

    if (this.props.syncType === 2) {
      columns = columns.filter(item => item.dataIndex !== "isHashed");
    }

    return (
      <Table rowKey="index" columns={columns} dataSource={table} size="middle" bordered pagination={false}
        title={() => (
          <div>
            {this.props.title}&nbsp;&nbsp;&nbsp;&nbsp;
            {
              this.props.syncType === 2 ? null :
                <Button style={{marginRight: "5px"}} type="primary" size="small" onClick={() => this.addRow(table)}>{i18next.t("general:Add")}</Button>
            }
          </div>
        )}
      />
    );
  }

  render() {
    return (
      <div>
        <Row style={{marginTop: "20px"}} >
          <Col span={24}>
            {
              this.renderTable(this.props.table)
            }
          </Col>
        </Row>
        <Modal
          visible={this.state.modalVisible}
          onOk={() => {
            this.updateTable(this.state.deleteTable);
            this.setState({modalVisible: false});
          }}
          onCancel={() => {
            this.setState({modalVisible: false});
          }}
        >
          {
            i18next.t("syncer:Sure to delete field")
          }
        </Modal>
      </div>
    );
  }
}

export default SyncerTableColumnTable;
